<template>
  <!--  配置系统 首页 -->
  <div class="projects-list">
    <el-dialog
      title="确认删除"
      custom-class="delete-project-dialog"
      v-model="deleteProjectDialogVisible"
      width="380px"
      top="30vh"
      :show-close="false"
      :before-close="handleClose"
    >
      <span>是否删除项目？</span>
      <template #footer>
        <span class="dialog-footer">
          <div class="dialog-footer-btns">
            <el-button size="mini" @click="deleteProjectDialogVisible = false">取 消</el-button>
            <el-button size="mini" @click="deleteProjects">确 定</el-button>
          </div>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      title="新建项目"
      custom-class="add-project-dialog"
      v-model="addProjectDialogVisible"
      width="430px"
      top="30vh"
      :show-close="false"
      :before-close="handleClose"
      @closed="handleClosed"
    >
      <div class="label-input">
        <span class="label">项目名称</span>
        <el-input size="medium" v-model="newProjectName"></el-input>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <div class="dialog-footer-btns">
            <el-button size="mini" @click="addProjectDialogVisible = false">取 消</el-button>
            <el-button :disabled="disableBtn" size="mini" @click="debounceAddProjects">确 定</el-button>
          </div>
        </span>
      </template>
    </el-dialog>
    <!-- 项目 显示 -->
    <div class="projects-list-main">
      <div class="list-header">
        <div class="projects-count">{{ `全部（${project_list.length}/9)` }}</div>
        <el-button type="primary" class="el-icon-plus" @click="handleAddProject">新建项目</el-button>
      </div>
      <div class="list-box">
        <div class="list-item" v-for="item in project_list" :key="item?.row_id">
          <div class="item-preview">
            <img :src="projectImg" alt="" />
            <div class="item-preview-mask">
              <div class="item-preview-btns">
                <el-button size="mini" icon="el-icon-edit" @click="editProject(item)">编辑</el-button>
                <el-button size="mini" icon="el-icon-delete" @click="openDeletePop(item.row_id)"
                  >删除
                </el-button>
              </div>
            </div>
          </div>
          <div class="item-info">
            <div class="item-project-name">{{ item.project_name }}</div>
            <div class="item-project-date">{{ item.create_time }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../../common/request';
import Api from '../../apis/api';

export default {
  name: 'ProjectsList',
  props: {
    user_id: String,
  },
  watch: {
    user_id: {
      deep: true,
      handler: function (newVal) {
        console.log(newVal, 'newValsha');
        this.userId = newVal;
        if (newVal !== '' || newVal !== undefined) {
          this.getProjects();
        }
      },
    },
  },
  data() {
    return {
      deleteProjectDialogVisible: false,
      addProjectDialogVisible: false,
      userId: '1',
      projectImg: require('../../../public/img/project_overview.jpg'),
      project_list: [],
      currentDeleteId: '',
      newProjectName: '',
      disableBtn: false,
    };
  },
  created() {
    this.userId = this.user_id;
    if (this.user_id !== '' || this.user_id !== undefined) {
      this.getProjects();
    }

    this.debounceAddProjects = this.$_.debounce(this.addProjects, 500);
  },
  methods: {
    handleClosed() {
      this.disableBtn = false;
    },
    handleClose() {
      this.currentDeleteId = '';
      this.newProjectName = '';
    },
    handleAddProject() {
      if (this.project_list.length >= 9) {
        this.$ElMessage.error('项目添加个数达到上限！');
        return;
      }
      this.addProjectDialogVisible = true;
      this.newProjectName = '';
    },
    editProject(data) {
      console.log(data, '项目 data pid pid');
      // 保存项目的row_id
      window.localStorage.removeItem('project_row_id');
      window.localStorage.setItem('project_row_id', data.row_id);
      window.localStorage.removeItem('backgroundDefault');
      if (data.config_data == 'null' || data.config_data == null) {
        let targetProjet = data;
        let rowDataString = targetProjet.config_data;
        rowDataString = rowDataString.replace(/^"/, '');
        rowDataString = rowDataString.replace(/"$/, '');

        let projectInfo = JSON.parse(rowDataString);

        if (projectInfo?.Background)
          window.localStorage.setItem('backgroundDefault', JSON.stringify(projectInfo.Background));
        if (targetProjet.is_publish === '1') {
          projectInfo.isPublished = true;
        }
        this.$store.commit('reset_ProjectEmpty');
        this.$store.commit('init_CurrentScene');

        this.$store.commit('set_ProjectID', targetProjet.row_id);
        this.$store.commit('set_ProjectPid', targetProjet.pid);
        this.$store.commit('set_ProjectName', targetProjet.project_name);
        this.$router.push({ name: 'Index' });
      } else {
        let targetProjet = data;
        let rowDataString = targetProjet.config_data;
        // 先执行正常基础处理（首尾去引号）
        rowDataString = rowDataString.replace(/^"/, '');
        rowDataString = rowDataString.replace(/"$/, '');

        let projectInfo;
        // 先按原格式解析
        try {
          projectInfo = JSON.parse(rowDataString);
          // 解析成功，直接执行后续逻辑
        } catch (error) {
          let processedString = rowDataString;
          processedString = processedString.replace(/^\s*\\\\?"\s*/, '');
          processedString = processedString.replace(/\s*\\+\s*$/, '');
          processedString = processedString
            // 先将 \\ 简化为 \（两个斜杠保留一个）
            .replace(/\\\\/g, '\\')
            // 再去除孤立的单个 \（不参与 \n 或 \\ 的斜杠）
            // 规则：匹配 \ 但后面不跟 n（排除 \n），且前面不是 \（排除已处理的单个 \）
            .replace(/(?<!\\)\\(?!n|r)/g, '');
          try {
            projectInfo = JSON.parse(processedString);
            console.log(projectInfo, '外格式处理后解析成功');
          } catch (secondError) {
            console.error('外格式处理后仍解析失败:', secondError);
            projectInfo = null; // 彻底失败的降级处理
          }
        }

        // let projectInfo = JSON.parse(rowDataString);

        if (projectInfo?.Background) console.log(projectInfo.Background, '22222222  projectInfo.Background');
        window.localStorage.setItem('backgroundDefault', JSON.stringify(projectInfo.Background));
        projectInfo.Name = targetProjet.project_name;
        if (targetProjet.is_publish === '1') {
          projectInfo.isPublished = true;
        }
        // 更新ProjectInfo数据
        this.$store.commit('set_allProjectInfo', projectInfo);
        // 更新当前场景id
        this.$store.commit('set_CurrentScene', projectInfo.SceneryList[0].id);
        // 保存项目id 用于提交修改项目数据到数据库
        this.$store.commit('set_ProjectID', targetProjet.row_id);
        this.$store.commit('set_ProjectPid', targetProjet.pid);
        this.$store.commit('set_ProjectName', targetProjet.project_name);
        this.$router.push({ name: 'Index' });
      }
    },
    getProjects() {
      if (!this.userId) {
        return;
      }
      //  场景 首页 接口
      let params = {
        method: 'post',
        url: Api.getUserProjects + '&rowId=' + this.userId,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      };
      request(params).then(res => {
        console.log(res, '场景---------');
        this.project_list = [];
        if (res?.data?.project_list) {
          this.project_list = res?.data?.project_list.filter(item => item != null);
        }
      });
    },
    openDeletePop(row_id) {
      this.deleteProjectDialogVisible = true;
      this.currentDeleteId = row_id;
    },
    addProjects() {
      // 添加接口
      this.disableBtn = true;
      let params = {
        method: 'post',
        url: Api.addProject,
        data: {
          project_name: this.newProjectName,
          user_id: this.userId,
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      };
      request(params)
        .then(res => {
          console.log(res, '添加接口');
          this.getProjects();
          this.addProjectDialogVisible = false;
          this.$ElMessage.success('添加成功！');
        })
        .catch(() => {
          this.$ElMessage.error('网络错误！');
        });
    },
    deleteProjects() {
      // 删除接口
      let params = {
        method: 'post',
        url: Api.deleteProject + `&row_id=${this.currentDeleteId}&user_id=${this.userId}`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      };
      request(params)
        .then(res => {
          console.log(res);
          this.$ElMessage.success('删除成功！');
          this.currentDeleteId = '';
          this.deleteProjectDialogVisible = false;
          this.getProjects();
        })
        .catch(() => {
          this.$ElMessage.error('网络错误！');
        });
    },
  },
};
</script>

<style lang="scss">
body {
  .el-dialog.add-project-dialog {
    background: rgb(32, 33, 43);

    .el-dialog__title {
      color: #ccc;
    }

    .el-dialog__body {
      /* padding: 0;
      height: 60px; */
      text-align: center;
      line-height: 50px;
      color: rgb(194, 200, 223);

      .label-input {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        /*  padding: 0 10px; */

        .label {
          width: 22%;
          margin: 0 4px;
          font-size: 15px;
          padding: 4px;
        }

        .el-input {
          /*  width: 60%; */

          .el-input__inner {
            background-color: rgb(39, 39, 39);
          }

          input {
            border: 1px solid rgb(100, 100, 100);
            color: #fff;

            &:focus {
              border: 1px solid rgb(76, 85, 204);
            }
          }
        }
      }
    }

    .dialog-footer-btns {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        width: 100px;
        color: #fff;
        border: 0;
      }

      .el-button:nth-child(1) {
        background-color: rgb(48, 50, 71);

        &:hover {
          background-color: rgb(39, 44, 63);
        }
      }

      .el-button:nth-child(2) {
        background-color: rgb(191, 40, 111);

        &:hover {
          background-color: rgb(145, 34, 86);
        }
      }
    }
  }

  .el-dialog.delete-project-dialog {
    background: rgb(32, 33, 43);

    .el-dialog__title {
      color: #ccc;
    }

    .el-dialog__body {
      /* height: 50px; */
      text-align: center;
      line-height: 50px;
      color: rgb(194, 200, 223);
    }

    .dialog-footer-btns {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        width: 100px;
        color: #fff;
        border: 0;
      }

      .el-button:nth-child(1) {
        background-color: rgb(48, 50, 71);

        &:hover {
          background-color: rgb(39, 44, 63);
        }
      }

      .el-button:nth-child(2) {
        background-color: rgb(191, 40, 111);

        &:hover {
          background-color: rgb(145, 34, 86);
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.projects-list {
  width: 100%;
  height: 100%;

  .projects-list-main {
    // height: 100%;
    width: 80%;
    padding-bottom: 20px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .list-header {
      user-select: none;
      width: 100%;
      height: 100px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .el-button {
        width: 140px;
        height: 34px;
        border-radius: 5px;
        color: #ffffff;
        border: 0;
        background: linear-gradient(135deg, #4633ff, #ae65ff);

        &:hover {
          background: linear-gradient(135deg, #472fa8, #9758bf);
        }
      }
    }

    .list-box {
      width: 100%;
      // height: 100%;
      flex-shrink: 1;
      margin-bottom: 100px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-content: flex-start;

      .list-item {
        flex-shrink: 0;
        width: 30%;
        max-width: 380px;
        height: 220px;

        // background-color: rgb(255, 255, 255);
        margin-bottom: 2%;
        border-radius: 8px;
        box-sizing: border-box;
        margin-left: 2%;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        &:hover > .item-preview > .item-preview-mask {
          background-color: #00000079;

          .el-button {
            display: block;
            border: 1px solid rgb(80, 67, 255);
            background-color: #000000b7;
            transition: all 0.4s ease-out;

            &:hover {
              // background: linear-gradient(135deg, #472fa8, #9758bf);
              background: linear-gradient(135deg, #4633ff, #ae65ff);
            }

            &:active {
              background: linear-gradient(135deg, #472fa8, #9758bf);
            }
          }
        }

        .item-preview {
          height: 80%;
          position: relative;
          user-select: none;

          img {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
          }

          .item-preview-mask {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            background-color: #00000000;
            transition: background-color 0.2s linear;
            display: flex;
            align-items: center;
            justify-content: center;

            .item-preview-btns {
              display: flex;
            }

            .el-button {
              display: none;
              color: rgba(255, 255, 255, 0.747);
            }
          }
        }

        .item-info {
          user-select: none;
          flex-shrink: 0;
          min-height: 50px;
          height: 20%;
          background: #363746;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: hsla(0, 0%, 100%, 0.5);

          .item-project-name {
            box-sizing: border-box;
            padding: 0 20px;
            font-size: 15px;
            margin-bottom: 5px;
          }

          .item-project-date {
            box-sizing: border-box;
            padding: 0 20px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
